var backgroundColorToken = function backgroundColorToken(intent) {
  var backgroundColor = 'product.primary';
  switch (intent) {
    case 'positive':
      backgroundColor = 'feedback.positive';
      break;
    case 'negative':
      backgroundColor = 'feedback.negative';
      break;
    case 'generic':
      backgroundColor = 'feedback.generic';
      break;
    default:
      backgroundColor = 'product.primary';
      break;
  }
  return backgroundColor;
};

export { backgroundColorToken };
//# sourceMappingURL=IndicatorBar.mappers.js.map
